import { ChangeFieldValueStep } from '../actionSectionTypes';

export const changeFieldValueRemoveVariable = (
  step: ChangeFieldValueStep,
  variableName: string,
  errorIds: string[]
) => {
  const nextErrorIds: string[] = [];

  if (
    step.details.changeType?.value === 'variable' &&
    step.details.variable?.value === variableName
  ) {
    if (!nextErrorIds.includes(step.id)) {
      nextErrorIds.push(step.id);
    }
    return {
      nextStep: {
        ...step,
        details: {
          ...step.details,
          variable: { ...step.details.variable, deleted: true },
        },

        hasError: true,
      },
      nextErrorIds,
    };
  }
  return { nextStep: step, nextErrorIds: [] };
};
